import { render, staticRenderFns } from "./NotificationWrapper.vue?vue&type=template&id=8d5872a6&"
import script from "./NotificationWrapper.vue?vue&type=script&lang=js&"
export * from "./NotificationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports